var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex align-content-center align-items-center"},[_c('customer-avatar',{attrs:{"customer":_vm.props.customer,"size":"2em"}}),_c('div',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.props.customer.name)+" - "+_vm._s(_vm.props.customer.mobile)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.props.customer.deliveryArea.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }